export const FEATURES = {
  QUESTION_CUSTOMISATION: "QUESTION_CUSTOMISATION",
  COMPLIANCE_TASKS: "COMPLIANCE_TASKS",
  MONITORING: "MONITORING",
} as const;

export type FeatureKey = (typeof FEATURES)[keyof typeof FEATURES];

export const FEATURE_PLAN_LABELS: Record<FeatureKey, string> = {
  [FEATURES.QUESTION_CUSTOMISATION]: "Boost",
  [FEATURES.COMPLIANCE_TASKS]: "Boost",
  [FEATURES.MONITORING]: "Boost",
};
